import { $, $$ } from 'utils/dom';
import Shower from 'modules/shower';

const showMores = $$('.showmore');

if (showMores.length) {
  showMores.forEach(showMore => {
    const target = $('.showmore__content', showMore);
    const handler = $('.showmore__button', showMore);

    new Shower({
      target,
      handler,
      easing: 'ease',
      duration: 400,
      initOpened: false,
      openClassName: 'showmore--active',
    }).init();
  });
}
